const stringifyArray = (data) => {
  return data?.map((item) => item.label).join(", ");
};
export default stringifyArray;
